import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, Dialog, DialogActions, DialogContent, IconButton, Typography } from '@mui/material';
import React from 'react';
import { headerTypographyProps } from '../../../styles/sxStyling';
import { dialogActionsStyles, dialogHeaderStyles } from './availabilityPanelStyles';

interface ScheduleInfoModalProps {
  open: boolean;
  onClose: () => void;
}

export default function ScheduleInfoModal({ open, onClose }: ScheduleInfoModalProps) {
  if (!open) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <Box sx={dialogHeaderStyles}>
        <Typography {...headerTypographyProps}>Schedule Info</Typography>

        <IconButton size="small" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent>
        <Typography>Schedule can only be changed by a manager.</Typography>
      </DialogContent>

      <DialogActions sx={dialogActionsStyles}>
        <Button variant="contained" onClick={onClose}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
